import { LOGO_ACCEPTED_TYPES } from '@UI/Pages/Administration/Organizations/Sidebars/LogoSidebar/FormData/constraint/logoConstraints';

/** A missing file is the required constraint's concern, not this one's. */
function isLogoFileTypeValid(value: File | null): boolean {
	return value === null || LOGO_ACCEPTED_TYPES.includes(value.type);
}

export default isLogoFileTypeValid;
